import type { PresetId, ProcessingOptions } from "../types";

export const defaultOptions: ProcessingOptions = {
  format: "webp",
  quality: 82,
  resize: {
    enabled: false,
    maintainAspectRatio: true,
    onlyShrink: true
  },
  preventLargerOutput: true,
  autoDownscaleLargeOutput: false,
  privacyFirst: false,
  jpegBackground: "#ffffff",
  suffix: "-optimized"
};

export const presets: Array<{ id: PresetId; label: string; apply: (current: ProcessingOptions) => ProcessingOptions }> = [
  {
    id: "smaller",
    label: "Smaller file",
    apply: (current) => ({ ...current, format: "webp", quality: 64, preventLargerOutput: true, autoDownscaleLargeOutput: true })
  },
  {
    id: "quality",
    label: "Best quality",
    apply: (current) => ({ ...current, quality: 92 })
  },
  {
    id: "web",
    label: "Web optimized",
    apply: (current) => ({ ...current, format: "webp", quality: 82, preventLargerOutput: true })
  },
  {
    id: "webp",
    label: "Convert to WebP",
    apply: (current) => ({ ...current, format: "webp" })
  },
  {
    id: "jpeg",
    label: "Convert to JPEG",
    apply: (current) => ({ ...current, format: "jpeg", jpegBackground: current.jpegBackground || "#ffffff" })
  },
  {
    id: "same",
    label: "Same format, smaller",
    apply: (current) => ({ ...current, quality: 72, preventLargerOutput: true, autoDownscaleLargeOutput: false })
  },
  {
    id: "safe",
    label: "Safe web upload",
    apply: (current) => ({
      ...current,
      format: "webp",
      quality: 78,
      preventLargerOutput: true,
      autoDownscaleLargeOutput: true,
      resize: { ...current.resize, enabled: true, width: 1920, height: undefined, maintainAspectRatio: true, onlyShrink: true }
    })
  },
  {
    id: "privacy",
    label: "Privacy-first export",
    apply: (current) => ({ ...current, format: "webp", quality: 82, preventLargerOutput: true, privacyFirst: true })
  }
];
